import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import {
  ViewerState,
  EquirectangularStoreState,
} from '@/modules/defines/interface';

// Utility for position comparison
export const isSamePosition = (pos1: number[], pos2: number[]): boolean =>
  pos1[0] === pos2[0] && pos1[1] === pos2[1] && pos1[2] === pos2[2];

const useEquirectangularStore = create<EquirectangularStoreState>()(
  subscribeWithSelector((set, get) => ({
    viewers: {},
    currentViewerKey: null,

    initializeViewer: (key, position, panorama, currentPosition) =>
      set((state) => {
        if (!state.viewers[key]) {
          return {
            viewers: {
              ...state.viewers,
              [key]: {
                position,
                panorama,
                visible: isSamePosition(position, currentPosition),
                opacity: isSamePosition(position, currentPosition) ? 1 : 0,
                radius: isSamePosition(position, currentPosition) ? 1 : 0.1,
              },
            },
          };
        }
        return state;
      }),

    updateViewer: (key, newProperties) =>
      set((state) => ({
        viewers: {
          ...state.viewers,
          [key]: {
            ...state.viewers[key],
            ...newProperties,
          },
        },
      })),

    setCurrentViewerKey: (key) =>
      set((state) =>
        state.currentViewerKey !== key ? { currentViewerKey: key } : state
      ),

    initializeAfterAllLoaded: () =>
      set((state) => {
        const viewerKeys = Object.keys(state.viewers);
        if (viewerKeys.length > 0) {
          const updatedViewers = viewerKeys.reduce((acc, key) => {
            acc[key] = {
              ...state.viewers[key],
            };
            return acc;
          }, {} as Record<string, ViewerState>);

          const visibleViewerKey = viewerKeys.find(
            (key) => state.viewers[key]?.visible
          );

          return {
            viewers: updatedViewers,
            currentViewerKey: visibleViewerKey || null, // visible 상태의 viewer가 없으면 null
          };
        }

        return state;
      }),

    getViewerByKey: (key: string) => get().viewers[key] || null,

    removeViewer: (key: string) =>
      set((state) => {
        const { [key]: _, ...remainingViewers } = state.viewers; // 특정 key 제거
        return { viewers: remainingViewers };
      }),
    isDragging: false,
    setIsDragging: (value: boolean) => set({ isDragging: value }),
  }))
);

export default useEquirectangularStore;
